<div>
  <a
    class="skip-main"
    (click)="skipToMainContent()"
    attr.aria-label="Skip to content"
    >Skip to main content</a
  >
</div>
